// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup .edit-theme {
  padding: 50px 20px 20px 20px;
}
.popup .edit-theme h2 {
  font: 2em/1 vigaregular;
  color: #5c5c5c;
}
.popup .edit-theme .tab-buttons {
  display: flex;
  justify-content: space-between;
}
.popup .edit-theme .tab-button {
  background: #f2f2f2;
  border-radius: 5px;
  color: #5c5c5c;
  cursor: pointer;
  display: inline-block;
  display: inline-grid;
  font: 1.6em/1 vigaregular;
  margin: 1% 0;
  padding: 20px 30px;
  width: 49%;
  text-align: center;
  justify-items: center;
  align-items: center;
}
.popup .edit-theme .tab-button.sm {
  padding: 5px;
}
.popup .edit-theme .tab-button.active {
  background: #caa36c;
  color: #fff;
}
.popup .edit-theme .twitter-picker {
  box-shadow: none !important;
}
.popup .edit-theme .twitter-picker div:nth-child(3) {
  padding: 0 !important;
}
.popup .edit-theme .row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.popup .edit-theme .row .options.larger {
  max-width: 170px;
}
.popup .edit-theme .item-texture {
  border: 2px solid #fff;
  border-radius: 10px;
  cursor: pointer;
  margin-right: 1%;
  margin-bottom: 1%;
  overflow: hidden;
  width: 32%;
}
.popup .edit-theme .item-texture:last-child {
  margin-right: 0;
}
.popup .edit-theme .item-texture.active {
  border-color: #caa36c;
}
.popup .edit-theme .item-texture img {
  width: 100%;
}
.popup .edit-theme input[type=file] {
  overflow: hidden;
  height: 0;
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/popups/EditThemeContent.scss"],"names":[],"mappings":"AACI;EACI,4BAAA;AAAR;AAEQ;EACI,uBAAA;EACA,cAAA;AAAZ;AAGQ;EACI,aAAA;EACA,8BAAA;AADZ;AAIQ;EACI,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AAFZ;AAIY;EACI,YAAA;AAFhB;AAKY;EACI,mBAAA;EACA,WAAA;AAHhB;AAOQ;EACI,2BAAA;AALZ;AAMY;EACI,qBAAA;AAJhB;AAQQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AANZ;AAQY;EACI,gBAAA;AANhB;AAUQ;EACI,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;AARZ;AAUY;EACI,eAAA;AARhB;AAWY;EACI,qBAAA;AAThB;AAYY;EACI,WAAA;AAVhB;AAeQ;EACI,gBAAA;EACA,SAAA;EACA,aAAA;AAbZ","sourcesContent":[".popup {\n    .edit-theme {\n        padding: 50px 20px 20px 20px;\n\n        h2 {\n            font: 2em/1 vigaregular;\n            color: #5c5c5c;\n        }\n\n        .tab-buttons{\n            display: flex;\n            justify-content: space-between;\n        }\n\n        .tab-button{\n            background: #f2f2f2;\n            border-radius: 5px;\n            color: #5c5c5c;\n            cursor: pointer;\n            display: inline-block;\n            display: inline-grid;\n            font: 1.6em/1 vigaregular;\n            margin: 1% 0;\n            padding: 20px 30px;\n            width: 49%;\n            text-align: center;\n            justify-items: center;\n            align-items: center;\n\n            &.sm{\n                padding: 5px;\n            }\n\n            &.active{\n                background: #caa36c;\n                color: #fff;\n            }\n        }\n\n        .twitter-picker{\n            box-shadow: none !important;\n            div:nth-child(3){\n                padding: 0 !important;\n            }\n        }\n\n        .row {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n\n            .options.larger{\n                max-width: 170px;\n            }\n        }\n\n        .item-texture{\n            border: 2px solid #fff;\n            border-radius: 10px;\n            cursor: pointer;\n            margin-right: 1%;\n            margin-bottom: 1%;\n            overflow: hidden;\n            width: 32%;\n\n            &:last-child{\n                margin-right: 0;\n            }\n\n            &.active{\n                border-color:#caa36c;\n            }\n\n            img{\n                width: 100%;\n            }\n        }\n\n\n        input[type=\"file\"] {\n            overflow: hidden;\n            height: 0;\n            display: none;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
